export const ADD_QUESTION = "ADD_QUESTION";
export const ADD_NEW_QUESTION = "ADD_NEW_QUESTION";
export const ADD_QUESTION_INTO_PARENT = "ADD_QUESTION_INTO_PARENT";
export const CLONE_QUESTION = "CLONE_QUESTION";
export const SORT_QUESTIONS = "SORT_QUESTIONS";
export const SORT_IN_GROUP_QUESTIONS = "SORT_IN_GROUP_QUESTIONS";
export const TAKE_OUT_GROUP_QUESTIONS = "TAKE_OUT_GROUP_QUESTIONS";
export const MOVE_QUESTION_FROM_GROUP_TO_GROUP = "MOVE_QUESTION_FROM_GROUP_TO_GROUP";
export const CHECK_QUESTION = "CHECK_QUESTION";
export const DELETE_QUESTION = "DELETE_QUESTION";
export const REORDER_QUESTIONS = "REORDER_QUESTIONS";
export const UPDATE_QUESTION_SETTING = "UPDATE_QUESTION_SETTING";
export const UPDATE_THEME_SETTING = "UPDATE_THEME_SETTING";
export const UPDATE_CHOICES_LIST = "UPDATE_CHOICES_LIST";
export const UPDATE_FORM_SETTINGS = "UPDATE_FORM_SETTING";
export const ADD_LANGUAGES = "ADD_LANGUAGES";
export const REMOVE_LANGUAGE = "REMOVE_LANGUAGE";
export const SET_DEFAULT_LANGUAGE = "SET_DEFAULT_LANGUAGE";
export const CHANGE_SETTING_CURRENT_LANGUAGE = "CHANGE_SETTING_CURRENT_LANGUAGE";
export const EXPORT_EXCEL = "EXPORT_EXCEL";
export const EXPORT_EXCEL_FINISHED = "EXPORT_EXCEL_FINISHED";
export const ADD_SCREEN = "ADD_SCREEN";
export const DELETE_SCREEN = "DELETE_SCREEN";
export const SET_CURRENT_SCREEN = "SET_CURRENT_SCREEN";
export const TOGGLE_DRAWER = "TOGGLE_DRAWER";
export const ADD_NEW_QUESTION_INTO_GROUP = "ADD_NEW_QUESTION_INTO_GROUP"
export const ADD_NEW_GROUP_QUESTION = "ADD_NEW_GROUP_QUESTION"
export const UPDATE_CHOICES_LIST_INIT = "UPDATE_CHOICES_LIST_INIT"
export const SET_PREVIEW = "SET_PREVIEW"
export const UPDATE_FORM_CONFIGS = "UPDATE_FORM_CONFIGS"
export const UPDATE_CONFIG_TEMP ="UPDATE_CONFIG_TEMP"

export const CHANGE_TAB = "CHANGE_TAB";
export const SURVEY_TAB = "SURVEY_TAB";
export const CHOICES_TAB = "CHOICES_TAB";
export const SETTINGS_TAB = "SETTINGS_TAB";



export const DEFAULT_MUTE_COLOR_HEX_CODE = "a7abc3";

export const DEFAULT_ORANGE_HEX_CODE = "fea500";
export const DEFAULT_GREY_HEX_CODE = "7f7f7f";
export const DEFAULT_DARK_GREY_HEX_CODE = "7c7c7c";
export const METRONIC_GREY_HEX_CODE = "ebedf2";